<template>
    <section class="progress-product">
        <title-date-component :titleOption="titleOption" :initDateRange="initDateRange" @changeDate="changeDate"></title-date-component>
        <section class="data-box">
            <nav-component :type="type" :currentType="rankType" @changeNavType="changeNavType"></nav-component>
            <table-component :tableInfo="tableInfo" style="margin-top:20px;"></table-component>
        </section>
        <tips-component :info="info"></tips-component>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .progress-product {
        background-color: #FFF;
	    padding: 30px 20px 10px 20px;
        margin-top: 20px;
        .data-box {
            width: 100%;
            padding-left: 15px;
            margin-top: 35px;
            padding-bottom: 15px;
        }
    }
</style>

<script>
    import TitleDateComponent from '../../../components/title-date/TitleDate.vue'
    import NavComponent from '../../../components/nav/Nav.vue'
    import TableComponent from '../../../components/table/Table.vue'
    import TipsComponent from '../../../components/tips/Tips.vue'
    import DataPlatform from 'api/dataPlatform'
    import MomentFormat from '../../../filters/moment-format'
    import percentformat from '../../../filters/percent-format'

    export default {
        components: {
            TitleDateComponent,
            NavComponent,
            TableComponent,
            TipsComponent
        },
        data () {
            return {
                titleOption: {  // 单元块名称和日期选择配置
                    title: '潜力商品',  // 名称
                    dateRadio: false,    // 是否显示昨天、本周、本月日期单选框
                    dateRangeSelect: true, // 是否显示日期区间下拉框
                    download: true, // 是否显示下载按钮
	                moduleId: 6,
	                bizCode: this.bizCode,
	                productId: [],
	                showDate: {
		                startDate: MomentFormat.getSevenDate(),
		                endDate: MomentFormat.getYestoday()
	                }
                },
                type: [
                    {
                        name: '流量提升',
                        value: '2'
                    },
                    {
                        name: '访购率提升',
                        value: '3'
                    },
                    {
                        name: '销量提升',
                        value: '4'
                    }
                ],
	            rankType: '2',
	            startDate: MomentFormat.getSevenDate(),  // 开始日期，默认昨天
	            endDate: MomentFormat.getYestoday(), // 结束日期，默认昨天
	            initDateRange: MomentFormat.getSevenDate() + ' ~ ' + MomentFormat.getYestoday(),
	            resultData: {},
                tableInfo: {
	                title: [
		                {
			                name: '商品名称',
			                value: 'productName',
			                style: 'width:25%;'
		                },
		                {
			                name: '浏览量',
			                value: 'intentionPv'
		                },
		                {
			                name: '流量增幅',
			                value: 'flowChg'
		                },
		                {
			                name: '访客数',
			                value: 'intentionUv'
		                },
		                {
			                name: '访购率',
			                value: 'purchaseRate'
		                },
		                {
			                name: '销量',
			                value: 'payQuantity'
		                },
		                {
			                name: '',
			                value: 'action'
		                }
	                ],
                    data: []
                },
	            info: {
		            value: 1,
		            suggest: "潜力商品是您近一段时间内表现有进步的商品，这些商品最近有增长势头，您可以根据分析其中增长的原因来判断：您的商品调整方案是否效；是否需要对应提升备货等。"
	            },
	            color: ['rgba(12, 222, 101, 1)', 'rgba(12, 222, 101, .8)', 'rgba(12, 222, 101, .6)',
                    'rgba(12, 222, 101, .4)', 'rgba(12, 222, 101, .2)']
            }
        },
        props: ["bizCode"],
        methods: {
            // 获取单品数据
	        getRankTypeData () {
		        DataPlatform.getRankTypeData(this.bizCode, this.startDate, this.endDate, parseInt(this.rankType))
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            let data = res.data;
                            let arr = [];
	                        let productId = [];
                            data.forEach((item, index) => {
                                let o = {};
                                o.productName = {};
                                o.productName.value = '<span style="background-color:' + this.color[index] + '">' +
                                    (index + 1) + '</span>' + item.productName;
                                o.intentionPv = {};
                                o.intentionPv.value = item.intentionPv;
	                            if (this.rankType === '2') {
		                            o.flowChg = {};
		                            o.flowChg.value = percentformat(item.flowChg, true);
	                            }
                                o.intentionUv = {};
                                o.intentionUv.value = item.intentionUv;
                                o.purchaseRate = {};
                                o.purchaseRate.value = percentformat(item.purchaseRate, true);
	                            if (this.rankType === '3') {
		                            o.purchaseRateChg = {};
		                            o.purchaseRateChg.value = percentformat(item.purchaseRateChg, true);
	                            }
                                o.payQuantity = {};
                                o.payQuantity.value = item.payQuantity;
	                            if (this.rankType === '4') {
		                            o.payQuantityChg = {};
		                            o.payQuantityChg.value = percentformat(item.payQuantityChg, true);
	                            }
                                o.action = {};
                                o.action.value = '<a href="javascript:void(0);">查看趋势</a>';
	                            o.action.showTc = true;
	                            o.action.params = {
		                            productId: item.productId,
		                            productName: item.productName,
		                            startDate: this.startDate,
		                            endDate: this.endDate
	                            };
	                            productId.push(item.productId);
                                arr.push(o);
                            });
                            this.tableInfo.data = arr;
	                        this.titleOption.productId = productId;
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    })
	        },

	        // 切换类型
	        changeNavType (type) {
		        this.rankType = type;
		        let arr = [
                    {
                        name: '商品名称',
                        value: 'productName',
                        style: 'width:25%;'
                    },
                    {
                        name: '浏览量',
                        value: 'intentionPv'
                    },
                    {
                        name: '访客数',
                        value: 'intentionUv'
                    },
                    {
                        name: '访购率',
                        value: 'purchaseRate'
                    },
                    {
                        name: '销量',
                        value: 'payQuantity'
                    },
                    {
                        name: '',
                        value: 'action'
                    }
                ];
		        if (this.rankType === '2') {
                    arr.splice(2, 0, {
	                    name: '流量增幅',
	                    value: 'flowChg'
                    })
                } else if (this.rankType === '3') {
			        arr.splice(4, 0, {
				        name: '访购率增幅',
                        value: 'purchaseRateChg'
			        })
                } else if (this.rankType === '4') {
			        arr.splice(5, 0, {
				        name: '销量涨幅',
				        value: 'payQuantityChg'
			        })
		        }
		        this.tableInfo.title = arr;
		        this.getRankTypeData();
	        },

	        // 切换日期
	        changeDate (params) {
		        this.startDate = params.dateRange.startDate;
		        this.endDate = params.dateRange.endDate;
		        this.getRankTypeData();
	        }
        },
	    mounted () {
		    this.getRankTypeData();
	    }
    }
</script>



// WEBPACK FOOTER //
// ProgressProduct.vue?33ae8c89